/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:03:49
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/form.js
 */
export default {
    // form 组件
    form: {
        model: () => ({}),
        rules: () => ({}),
        errorType: 'message',
        borderBottom: true,
        labelPosition: 'left',
        labelWidth: 45,
        labelAlign: 'left',
        labelStyle: () => ({})
    }
}
